<template>
<div>

    <v-dialog v-model="dialog" persistent max-width="800" scrollable>
        <v-card>
            <v-card-title class="text-h5 pl-6 font-weight-regular">{{id?'Edit':'Add'}} Vendor
                <v-spacer/><v-btn icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title><v-divider/>
            <v-progress-linear :active="$apollo.queries.Vendors.loading" :indeterminate="true"/>
            <v-card-text class="mt-4">
                <v-form ref="form">
                    <v-row>
                      <v-col cols="12 text-center">
                        <label class="text-uppercase grey--text font-weight-bold">Profile Picture</label>
                        <br>
                        <input id="file-vendor" @change="onSelectFile" type="file" accept=".png, .jpg, .jpeg, .jfif" v-if="dialog" style="display: none"/>
                        <v-badge
                            avatar
                            overlap
                            color="white"
                            class="mt-3"
                        >
                          <template v-slot:badge>
                            <v-btn v-if="form.profileImage" @click.stop="removeImage" elevation="0" x-small dark icon
                                   color="red" title="Remove Image"><v-icon>mdi-close</v-icon></v-btn>
                          </template>
                          <v-avatar @click="openFile" color="grey lighten-2" size="100">
                            <ImageBox :imageLoading="imageLoading" :imageUrl="form.profileImage"/>
                          </v-avatar>
                        </v-badge>

<!--                        <v-avatar class="image-div mt-3" @click="openFile" color="grey lighten-2" size="100">-->
<!--                          <ImageBox :imageLoading="imageLoading" :imageUrl="form.profileImage"/>-->
<!--                          <v-btn v-if="form.profileImage" @click.stop="removeImage" elevation="0" x-small dark icon-->
<!--                                 class="remove-img-btn" color="red" title="Remove Image"><v-icon>mdi-close</v-icon></v-btn>-->
<!--                        </v-avatar>-->
                      </v-col>
                        <v-col cols="12" class="pb-0">
                            <v-row>
                                <v-col cols="6" class="pt-0">
                                    <label class="text-uppercase grey--text font-weight-bold">Name*</label>
                                    <v-text-field outlined v-model="form.name" class="mt-3" maxlength="50" counter
                                                  :rules="[v => !!v || 'Name Required', v => v.length >= 3 || 'Enter minimum 3 characters']"/>
                                </v-col>
                                <v-col cols="6" class="pt-0">
                                    <label class="text-uppercase grey--text font-weight-bold">Vendor Code*</label>
                                    <v-text-field outlined v-model="form.vendorCode" class="mt-3" maxlength="50" counter
                                                  :rules="[v => !!v || 'Vendor Code Required', v => v.length >= 3 || 'Enter minimum 3 characters']"/>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">City</label>
                            <v-autocomplete outlined  class="mt-3" :items="cities" :search-input.sync="searchCity"
                                            v-model="form.city" @change="onSelectCity"
                                            item-text="name" return-object :loading="$apollo.queries.cities.loading"/>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">Transportation</label>
                            <v-text-field outlined v-model="form.transportation" class="mt-3" maxlength="50" counter
                                          :rules="[v => !v || v.length >= 3 || 'Enter minimum 3 characters']"/>
                        </v-col>
                      <v-col cols="12" class="pt-0">
                        <h6 style="font-size: 20px" class="black--text">Bank Details</h6>
                      </v-col>
                        <v-col cols="6" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">Bank Name</label>
                            <v-text-field outlined v-model="form.bankName" class="mt-3"/>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">Account Name</label>
                            <v-text-field outlined v-model="form.accountName" class="mt-3"/>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">Account Number</label>
                            <v-text-field outlined v-model="form.accountNumber" class="mt-3"/>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">IFSC Code</label>
                            <v-text-field outlined v-model="form.ifscCode" class="mt-3"/>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="pa-3">
                <v-spacer></v-spacer>
                <v-btn class="text-capitalize elevation-0 mr-2" @click="closeDialog">Cancel</v-btn>
                <v-btn class="primary px-3 text-capitalize" :loading="formLoading" dark @click="handleSubmit">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <Snackbar :toaster="toaster"/>
</div>
</template>

<script>
import Constants from "../../../Constants/Constants";
import moment from 'moment';
import Snackbar from "../../../components/Common/Snackbar";
import ImageBox from "../../../components/Common/ImageBox";
import NetworkCommunicator from "../../../plugins/NetworkResourceHandler";
import {GET_VENDOR_BY_ID} from "../../../graphql/queries/Vendors";
import {CREATE_UPDATE_VENDOR} from "../../../graphql/mutations/Vendors";
import {GET_ALL_CITIES} from "../../../graphql/queries/Territories";
import {debounce} from "lodash";
let user = JSON.parse(localStorage.user);
let form = { name:'', vendorCode:'', profileImage:'', city:'', transportation:'', bankName:'', accountName:'', accountNumber: '', ifscCode:'',
             createdBy:user.id, updatedBy:user.id };

export default {
    name: "VendorForm",
    components: {ImageBox, Snackbar},
    props: ['dialog', 'id'],
    apollo: {
        Vendors: {
            query: GET_VENDOR_BY_ID,          //Always fetch createdBy to override default
            fetchPolicy: 'network-only',
            skip () {return !this.id},
            variables(){ return{ id: this.id } },
            result ({data}) {
                Object.copyExistingKeys(this.form = {...form, id:''}, data.Vendors[0]);
                this.filterCity = this.form.city || null;
            },
        },
        cities: {
            query: GET_ALL_CITIES,
            variables(){ return{ city: '%' +this.filterCity+ '%' } }
        },
    },
    data(){
        return{
            moment: moment,
            Constants: Constants,
            form: {...form},
            formLoading: false, imageLoading: false,
            cities: [], searchCity: null, filterCity: null,
            toaster: {enable: false},
            maxFileSize: 1048576,        /* 1MB */
        }
    },
    watch: {
        searchCity: debounce(function(val) {
            if(val?.length > 1) this.filterCity = val
        }, 500)
    },
    methods:{
        onSelectCity(val){
            this.form.city = val.name;
        },
        removeImage(){
          this.form.profileImage = ''
        },
        openFile(){
            document.getElementById('file-vendor').click();
        },
        onSelectFile(evt){
            let file = evt.target.files[0];
            if(!file) return;
            if(file.size>this.maxFileSize) return this.toaster = {enable: true, color: 'red', message: `File is too big! Please upload file with size less than ${this.maxFileSize / 1048576}MB`};
            this.imageLoading = true;
            let formData = new FormData();
            formData.append('image', file);
            formData.append('name', file.name);
            NetworkCommunicator('POST', Constants.api_url + 'v1/upload', formData).then(res => {
                if(res.flag) this.form.profileImage = res.data;
                else this.toaster = {enable:true, color:'red', message: 'Image Upload Failed'};
                this.imageLoading = false
            }).catch(function(err){
                console.log('Upload File Error', err);
                this.toaster = {enable:true, color:'red', message: 'Image Upload Failed'};
                this.imageLoading = false
            })
        },
        handleSubmit(){
            if(this.$refs.form.validate()) this.saveVendor()
        },
        async saveVendor(){
            this.formLoading = true;
            let response = await this.$apollo.mutate({
                mutation: CREATE_UPDATE_VENDOR,
                variables: {
                    vendor: { ...this.form },
                    updateColumns: [...Object.keys(this.form)],
                }
            });
            if(response.data){
                this.formLoading = false;
                this.toaster = {enable:true, color:'green', message: `Vendor saved Successfully`};
                this.closeDialog();
            }
        },
        closeDialog(){
            this.$refs.form.resetValidation();
            this.form = {...form};
            this.$emit('update:dialog', false);
            this.$emit('update:id', null);
        }
    }
}
</script>

<style scoped>
.image-div{
    width: 360px;
    height: 180px;
    /*margin: auto;*/
}
.remove-img-btn{
    z-index: 9999;
    position: absolute;
    top: 4px;
    right: 4px;
}
</style>
